import { Component } from '@angular/core';

import { ITableFilterPassedParams } from '../../../models/filter-passed-params';
import { RendererBaseComponent } from '../renderer-base.component';
import { ILinkRendererFilterData } from './link-renderer-filter-data';

@Component({
    templateUrl: 'link-renderer.component.html',
    standalone: false
})
export class LinkRendererComponent extends RendererBaseComponent {

    public linkExpr: (rowModel: any, cellModel?: any) => string | any[];

    public isClickableExpr?: (rowModel: any) => boolean;

    public filterData?: ILinkRendererFilterData;

    public external?: boolean;

    public hasIcon?: boolean;

    constructor() {
        super();
    }

    public isClickable(rowModel: any): boolean {

        if (this.isClickableExpr) {
            return this.isClickableExpr(rowModel);
        }

        return true;
    }

    public getFilterParams(rowModel: any): ITableFilterPassedParams {

        if (this.filterData) {

            const filterValue = this.filterData.filterValueColumns.length > 1
                ? this.filterData.filterValueColumns.reduce((previous, current) => rowModel[previous] + ' ' + rowModel[current])
                : rowModel[this.filterData.filterValueColumns[0]];

            return {
                filterColumn: this.filterData.filterColumnName,
                filterValue: filterValue
            };
        }

        return null;
    }
}
